import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMathLessThanCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMathLessThanCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM15.3194 7.73857L7.12435 12L15.3194 16.2614L16.0114 14.9306L10.3757 12L16.0114 9.0694L15.3194 7.73857Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMathLessThanCircle;
